<pipeline-post [post]="post"></pipeline-post>